var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataLyzeNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 23,
    viewBox: "0 0 179 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7871 3.85352H46.5129C52.3703 3.85352 55.6384 6.5507 55.6384 11.3966C55.6384 16.2426 52.3703 18.9397 46.5129 18.9397H35.7871V3.85352ZM45.7532 15.2131C48.6617 15.2131 50.3024 13.8421 50.3024 11.4011C50.3024 8.96018 48.6572 7.56663 45.7532 7.56663H41.1365V15.2176H45.7532V15.2131Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7179 3.85352H69.1012L76.4555 18.9397H70.7465L69.5687 16.3055H62.0481L60.8883 18.9397H55.1973L62.7179 3.85352ZM68.5123 13.2082L65.8556 7.24297H65.8152L63.118 13.2082H68.5123Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5361 7.72847H74.6562V3.85352H91.9137V7.72847H86.0339V18.9397H80.5361V7.72847Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6515 3.85352H104.035L111.389 18.9397H105.68L104.502 16.3055H96.9817L95.8219 18.9397H90.1309L97.6515 3.85352ZM103.446 13.2082L100.789 7.24297H100.749L98.0516 13.2082H103.446Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.465 3.85352H117.963V14.9165H127.129V18.9397H112.465V3.85352Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.072 13.7971L123.74 3.85352H129.535L133.832 10.2189H133.855L137.941 3.85352H143.798L136.57 13.7971V18.9397H131.072V13.7971Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.492 14.831L154.732 7.41379H144.703L144.789 3.85352H160.994L160.932 8.02516L150.691 15.3795H161.143V18.9397H144.497V14.831H144.492Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.881 3.85352H178.79V7.26545H168.212V9.79181H177.949V12.7227H168.212V15.5233H179.001V18.9353H162.881V3.85352Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5597 7.63281L4.99414 15.8277",
    stroke: "#A938F7",
    strokeWidth: 1.57573,
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.3588H14.7131C17.3114 20.3588 19.4197 18.4348 19.4197 16.0613V6.29751C19.4197 3.92399 17.3114 2 14.7131 2H0",
    stroke: "#24E889",
    strokeWidth: 3.61659,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18513 7.4668L5.70903 8.37485L2.1038 10.4742L5.70903 12.56L4.33347 13.504L0 10.8203V9.93022L4.18513 7.4668Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6338 13.0078H11.7363V16.9052H15.6338V13.0078Z",
    fill: "#1EEB88"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6621 16.9023H15.6348V18.9297H17.6621V16.9023Z",
    fill: "#1EEB88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataLyzeNew);
export default __webpack_public_path__ + "static/media/dataLyze-new.68dc249a00c349a4347df98bb30be22b.svg";
export { ForwardRef as ReactComponent };